import {Component, signal} from '@angular/core';
import {TBaseCommonComponent} from '../../../../shared/components/base-components/t-base-common.component';
import {CommonService} from '../../../../shared/services/common.service';
import {TopbarComponent} from '../topbar/topbar.component';
import {RouterOutlet} from '@angular/router';
import {SidebarComponent} from '../sidebar/sidebar.component';

@Component({
  selector: 'app-layout.component',
  standalone: true,
  imports: [
    TopbarComponent,
    RouterOutlet,
    SidebarComponent
  ],
  templateUrl: 'layout.component.html',
  styleUrl: 'layout.component.scss'
})
export class LayoutComponent extends TBaseCommonComponent {
  constructor() {
    super();
  }

  isSidebarOpen = signal<boolean>(false);

  toggleSidebar() {
    this.isSidebarOpen.set(!this.isSidebarOpen());
  }
}
